import React, {useEffect, useState} from 'react';
import {Modal} from 'src/core/layout/modal';

interface RenameProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRename: (newName: string) => void;
  projectName: string;
}

export const RenameProjectModal: React.FC<RenameProjectModalProps> = ({
  isOpen,
  onClose,
  onRename,
  projectName,
}) => {
  const [newName, setNewName] = useState(projectName);

  useEffect(() => {
    if (isOpen) {
      setNewName(projectName);
    }
  }, [projectName, isOpen]);

  const handleSubmit = () => {
    if (newName.trim()) {
      onRename(newName.trim());
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="w-full max-w-md">
      <div>
        <h2 className="text-xl font-semibold mb-4">Rename Project</h2>
        <input
          type="text"
          value={newName}
          onChange={e => setNewName(e.target.value)}
          className="border border-gray-300 w-full p-2 mb-4 rounded"
        />
        <div className="flex justify-end space-x-2">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
          >
            Rename Project
          </button>
        </div>
      </div>
    </Modal>
  );
};
